/**
 * Scroll reveals for custom LM homepage sections.
 */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[data-lm-reveal]').forEach((el) => el.classList.add('is-visible'));
    return;
  }

  document.documentElement.classList.add('lm-motion');

  const boot = () => {
    const targets = [...document.querySelectorAll('[data-lm-reveal]')].filter(
      (el) => !el.classList.contains('is-visible') && !el.classList.contains('lm-hero')
    );

    // Hero reveals via CSS animation; mark visible for consistency
    document.querySelectorAll('.lm-hero[data-lm-reveal]').forEach((el) => el.classList.add('is-visible'));

    if (!('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
    );

    targets.forEach((el) => observer.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', () => requestAnimationFrame(boot));
})();
